<framework-assets-image
  [assetFile]="assetFile"
  [size]="size"
  (loaded)="loaded.emit(true)"
  (errored)="errored.emit(true)"
>
  <framework-asset-image-content>
    @if (details) {
    <div class="left" (click)="openLink()">
      <div class="top">
        <framework-work-status-chip
          [workStatus]="$safeNavigationMigration($any(project)?.status)"
          [darkMode]="true"
        ></framework-work-status-chip>
        <p class="subtitle">
          {{ project.productType ? project.productType.name + ' •' : null }} {{ project.projectEndDate | date : 'MMM dd,
          yyyy' }}
        </p>
      </div>
      <p class="title">{{ $any(project)?.feedDetails.organizationName || $any(project)?.feedDetails.feedName}}</p>
      <p class="title">{{ project?.name }}</p>
    </div>
    }

    <div class="click" (click)="openLink()"></div>

    @if (showMembers === true && project?.members) {
    <framework-clusted-profile-images [userList]="project.members"> </framework-clusted-profile-images>
    }
  </framework-asset-image-content>
</framework-assets-image>
